import React from 'react';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom'

class ExploreProductColumn extends React.Component{
    render(){
        return(
            <div className="col-5">
                {this.props.exploreProductColData.map((exploreProductContent, i) => (
                    <div className="row" key={i}>
                        <div className="card-body expolre-cards-desktop">
                            <h5 className="card-title">{exploreProductContent.title}</h5>
                            <div className="card-text">
                                <ul className="list-group">
                                    {exploreProductContent.child_items.map((productList) => (
                                        <li className="list-group-item" key={productList.title}>
                                            {(productList.url.indexOf('http://') === 0 || productList.url.indexOf('https://') === 0)?
                                            <a href={productList.url} data-tip data-for={"productTooltip"+productList.title}>
                                                {productList.title}
                                            </a>:
                                            <Link to={productList.url} data-tip data-for={"productTooltip"+productList.title}>
                                                {productList.title}
                                            </Link>
                                            }
                                            <ReactTooltip id={"productTooltip"+productList.title} className="tooltip-inner"
                                            backgroundColor="#fafafa" textColor="#000">
                                                {productList.full_title}
                                            </ReactTooltip>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}
export default ExploreProductColumn